export { default } from "./ReservationDetails";